<template>
  <Toast />
  <div class="card-header">
    <h4>Lista de Precios x Movimientos</h4>
    <div class="line_title"></div>
  </div>
  <div class="card-body">
    <div>
      <!-- DT MPrecios -->
      <DataTable ref="dt" :value="mprecios" :paginator="true" :rows="10" style="zoom: 0.80;" :loading="loading" 
      removableSort :globalFilterFields="['id', 'tmovimiento.nombre','tcamion.nombre','origen.descripcion','destino.descripcion', 'precio', 'fecha', 'vigente']" sortMode="multiple" dataKey="id" filterDisplay="row" 
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" v-model:filters="filters"
        v-model:selection="selectedMPrecios" responsiveLayout="scroll" breakpoint="990px">
        <template #header>
          <!-- DT Toolbar-->
          <Toolbar class="">
            <template #start>
              <div class="table-header flex flex-column md:flex-row md:justiify-content-between">
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText v-model="filters['global'].value" placeholder="Buscar..." />
                </span>
              </div>              
            </template>

            <template #end>
              <Button label="Crear" icon="pi pi-plus" class="p-button-success" @click="openNew" />
            </template>
          </Toolbar>
        </template>

        <Column field="id" header="Cod." sortable :hidden="true">
          <template #body="slotProps">
            <span>
              {{ slotProps.data.id }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="" />
          </template>
        </Column>

        <Column field="tmovimiento.nombre" header="Tipo Movimiento"  style="white-space: nowrap;" sortable>
          <template #body="slotProps">
            <span>
              {{ slotProps.data.tmovimiento.nombre }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="" />
          </template>          
        </Column>

        <Column field="tcamion.nombre" header="Tipo Camión"  style="white-space: nowrap;" sortable>
          <template #body="slotProps">
            <span>
              {{ slotProps.data.tcamion.nombre }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="" />
          </template>          
        </Column>

        <Column field="origen.descripcion" header="Origen" sortable>
          <template #body="slotProps">
            <span>
              {{ slotProps.data.origen ? slotProps.data.origen.descripcion.slice(0, 23) : '' }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="" />
          </template>          
        </Column>

        <Column field="destino.descripcion" header="Destino" sortable>
          <template #body="slotProps">
            <span>
              {{ slotProps.data.destino ? slotProps.data.destino.descripcion.slice(0, 23) : '' }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="" />
          </template>          
        </Column>

        <Column field="precio" header="Precio" sortable style="text-align: right;">
          <template #body="slotProps">
            <span>
              {{ formatCurrency(slotProps.data.precio)}}
            </span>            
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="" />
          </template>          
        </Column>            

        <Column field="fecha" header="Fecha" sortable>
          <template #body="slotProps">
            <span>
              {{ slotProps.data.fecha }}
            </span>            
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="" />
          </template>          
        </Column>

        <Column field="vigente" header="Vigente" sortable>
          <template #body="slotProps">
            <span>
              <i class="pi pi-center" :class="{ 'pi-check-circle text-success': slotProps.data.vigente, 'pi-times-circle text-danger': !slotProps.data.vigente }"></i>
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="" />
          </template>           
        </Column>

        <Column header="Acciones" :exportable="false" style="white-space: nowrap;">
          <template #body="slotProps">
            <Button icon="pi pi-pencil" class="p-button-rounded p-button-warning"
              @click="editMPrecio(slotProps.data)" />&nbsp;
            <Button icon="pi pi-trash" class="p-button-rounded p-button-danger"
              @click="confirmDeleteMPrecio(slotProps.data)" />
          </template>
        </Column>
      </DataTable>
    </div>

    <!-- Formulario MPrecios en modal -->
    <Dialog v-model:visible="mprecioDialog" :style="{ width: '90vw' }" header="Precios x Tipo de  Movimiento" :modal="true"
      class="p-fluid" :maximizable="true">
      <form class="p-fluid">
        <div class="row">
          <div class="col-md-12 field">
            <div class="row">              
              <div class="col-md-6 field">
                <label for="tmovimiento" class="mt-3">Tipo Movimiento</label>
                <AutoComplete id="tmovimiento" v-model="v$.tmovimiento.$model"
                  :class="{ 'p-invalid': v$.tmovimiento.$invalid && submitted }" :suggestions="filteredTMovimientos"
                  @complete="searchTMovimiento($event)" field="_nombre" :dropdown="true" forceSelection
                  @change="setDocumento($event)" 
                  aria-describedby="tmovimiento-error" autofocus autocomplete="off"/>
                <span v-if="v$.tmovimiento.$error && submitted">
                  <span id="tmovimiento-error" v-for="(error, index) of v$.tmovimiento.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="((v$.tmovimiento.$invalid && submitted) || v$.tmovimiento.$pending.$response)"
                  class="p-error">
                  {{ v$.tmovimiento.required.$message.replace('Value', 'Tipo Movimiento') }}</small>
              </div>                             
            
              <div class="col-md-6 field">
                <label for="tcamion" class="mt-3">Tipo Camión</label>
                <AutoComplete id="tcamion" v-model="v$.tcamion.$model"
                  :class="{ 'p-invalid': v$.tcamion.$invalid && submitted }" :suggestions="filteredTCamiones"
                  @complete="searchTCamion($event)" field="_nombre" :dropdown="true" forceSelection
                  aria-describedby="tcamion-error" autofocus autocomplete="off" />
                <span v-if="v$.tcamion.$error && submitted">
                  <span id="tcamion-error" v-for="(error, index) of v$.tcamion.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="((v$.tcamion.$invalid && submitted) || v$.tcamion.$pending.$response)"
                  class="p-error">
                  {{ v$.tcamion.required.$message.replace('Value', 'Tipo Camión') }}</small>
              </div> 
            </div>           
      
            <div class="row">
              <div class="col-md-6 field" v-if="es_normal">
                <label for="origen" class="mt-3">Origen</label>
                <AutoComplete id="origen" v-model="v$.origen.$model"
                  :class="{ 'p-invalid': v$.origen.$invalid && submitted }" :suggestions="filteredOrigenes"
                  @complete="searchOrigen($event)" field="_descripcion" :dropdown="true" forceSelection
                  aria-describedby="origen-error" autofocus autocomplete="off" />
                <span v-if="v$.origen.$error && submitted">
                  <span id="origen-error" v-for="(error, index) of v$.origen.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="((v$.origen.$invalid && submitted) || v$.origen.$pending.$response)"
                  class="p-error">
                  {{ v$.origen.required.$message.replace('Value', 'Origen') }}</small>
              </div>
              <div class="col-md-6 field" v-if="es_normal">
                <label for="destino" class="mt-3">Destino</label>
                <AutoComplete id="destino" v-model="v$.destino.$model"
                  :class="{ 'p-invalid': v$.destino.$invalid && submitted }" :suggestions="filteredDestinos"
                  @complete="searchDestino($event)" field="_descripcion" :dropdown="true" forceSelection
                  aria-describedby="destino-error" autofocus autocomplete="off" />
                <span v-if="v$.destino.$error && submitted">
                  <span id="destino-error" v-for="(error, index) of v$.destino.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="((v$.destino.$invalid && submitted) || v$.destino.$pending.$response)"
                  class="p-error">
                  {{ v$.destino.required.$message.replace('Value', 'Destino') }}</small>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 field">
                <label for="km" class="mt-3">Kilometros</label>
                <InputNumber id="km" v-model.trim="v$.km.$model" :class="{ 'p-invalid': v$.km.$invalid && submitted }" aria-describedby="km-error" autofocus
                autocomplete="off" />
                <span v-if="v$.km.$error && submitted">
                  <span id="km-error" v-for="(error, index) of v$.km.$errors" :key="index">
                    <small class="p-error">{{ error.$message }} </small>
                  </span>
                </span>
                <small v-else-if="(v$.km.$invalid && submitted) || v$.km.$pending.$response" class="p-error">
                  {{ v$.km.required.$message.replace('Value', 'Kilometros') }}</small> 
              </div>              
              <div class="col-md-6 field">
                <label for="precio" class="mt-3">Precio</label>
                <InputNumber id="precio" v-model.trim="v$.precio.$model" :class="{ 'p-invalid': v$.precio.$invalid && submitted }" aria-describedby="precio-error" autofocus
                autocomplete="off" />
                <span v-if="v$.precio.$error && submitted">
                  <span id="precio-error" v-for="(error, index) of v$.precio.$errors" :key="index">
                    <small class="p-error">{{ error.$message }} </small>
                  </span>
                </span>
                <small v-else-if="(v$.precio.$invalid && submitted) || v$.precio.$pending.$response" class="p-error">
                  {{ v$.precio.required.$message.replace('Value', 'Kilometros') }}</small>
              </div>              
            </div>
            <div class="row">
              <div :class="form.vigente ? 'col-md-8' : 'col-md-12'" class="field">
                <label for="observacion" class="mt-3">Observaciones</label>
                <InputText id="observacion" v-model.trim="form.observacion" />
              </div>          
              <div class="col-md-4 field" v-if="form.vigente">
                <label for="vigente" class="mt-3">Estado</label><br>
                <ToggleButton id="vigente" v-model="v$.vigente.$model"
                  :class="{ 'p-invalid': v$.vigente.$invalid && submitted }" onLabel="ACTIVO" offLabel="INACTIVO"
                  onIcon="pi pi-check" offIcon="pi pi-times" aria-describedby="vigente-error" autofocus
                  style="width: 100%"/>
                <span v-if="v$.vigente.$error && submitted">
                  <span id="vigente-error" v-for="(error, index) of v$.vigente.$errors" :key="index">
                    <small class="p-error">{{ error.$message }}</small>
                  </span>
                </span>
                <small v-else-if="(v$.vigente.$invalid && submitted) || v$.vigente.$pending.$response" class="p-error">
                  {{ v$.vigente.required.$message.replace('Value', 'Estado') }}</small>
              </div>                  
            </div>           
          </div>
        </div>
      </form>

      <template #footer>
        <div class="row">
          <div class="col-md-7 fw-lighter text-muted" style="text-align: left;">
            <small v-if="form.created_id" ><i class="pi pi-user-plus" style="font-size: 1rem"></i>: {{form.created_id.name}} el {{form.created_at}}</small><br/>
            <small v-if="form.updated_id"><i class="pi pi-user-edit" style="font-size: 1rem"></i>: {{form.updated_id.name}} el {{form.updated_at}}</small>    
          </div>  
          <div :class="form.created_id ? 'col-md-5 field' : 'col-md-12 field'" v-if="!saving">
            <Button label="Cancelar" icon="pi pi-times" class="p-button-text text-danger" @click="openNew(false)" />
            <Button label="Guardar" icon="pi pi-check" class="p-button-text" @click="saveMPrecio" />
          </div>
          <div :class="form.created_id ? 'col-md-5 field' : 'col-md-12 field'" v-else>
            <ProgressBar mode="indeterminate"/>
          </div>
        </div>
      </template>
    </Dialog>

    <!-- Confirmar elimina un mprecio -->
    <Dialog v-model:visible="deleteMPrecioDialog" :style="{ width: '470px' }" header="Confirmar" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-3 text-warning" style="font-size: 2rem; vertical-align: middle;" />
        <span v-if="mprecio"> ¿Está seguro de borrar el precio?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteMPrecioDialog = false" />
        <Button label="Si" icon="pi pi-check" class="p-button-text text-danger" @click="deleteMPrecio" />
      </template>
    </Dialog>

    <!-- Confirmar elimina masivamente precios -->
    <Dialog v-model:visible="deleteMPreciosDialog" :style="{ width: '470px' }" header="Confirmar" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-2 text-warning" style="font-size: 2rem; vertical-align: middle;" />
        <span v-if="selectedMPrecios"> ¿Está seguro de borrar los precios seleccionados?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteMPreciosDialog = false" />
        <Button label="Si" icon="pi pi-check" class="p-button-text text-danger" @click="deleteSelectedMPrecios" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import useMPrecios from '../../composables/cruds/mprecios'
import { reactive, onMounted, ref } from 'vue'

import useVuelidate from '@vuelidate/core'
import { required, helpers, requiredIf } from '@vuelidate/validators'
import readXlsxFile from 'read-excel-file'

export default {
  setup() {
    const {
      mprecio,
      mprecios,
      tmovimientos,
      tcamiones,
      origenes,
      destinos,
      dt,
      loading,
      saving,
      filters,
      selectedMPrecios,
      selectedTMovimientos,
      selectedTCamiones,
      deleteMPrecioDialog,
      mprecioDialog,
      submitted,
      filteredTMovimientos,
      filteredDestinos,
      filteredOrigenes,
      filteredTCamiones,
      getCRUD,
      storeMPrecio,
      deleteMPrecio
    } = useMPrecios()

    const es_normal = ref()

    const form = reactive({
      tmovimiento: '',
      tcamion: '',
      origen: '',
      destino: '',      
      km: 0,
      precio: 0,
      vigente: '',
      observacion: ''
    })      

    const openNew = (show = true) => {
      mprecio.value = {}
      submitted.value = false
      mprecioDialog.value = show
      saving.value = false
      
      form.value = {} 
      form.tmovimiento = ''
      form.tcamion = ''
      form.origen = ''
      form.destino = ''
      form.km = 0
      form.precio = 0
      form.vigente = true
      form.observacion = ''
    }

    const editMPrecio = (mp) => { 
      mprecio.value = { ...mp }
      mprecioDialog.value = true

      form.value = {} 
      form.tmovimiento = mprecio.value.tmovimiento
      form.tcamion = mprecio.value.tcamion
      form.origen = mprecio.value.origen
      form.destino = mprecio.value.destino
      form.km = mprecio.value.km
      form.precio = mprecio.value.precio     
      form.vigente = mprecio.value.vigente     
      form.observacion = mprecio.value.observacion

      form.created_at = mprecio.value.created_at
      form.created_id = mprecio.value.created_id
      form.updated_at = mprecio.value.updated_at
      form.updated_id = mprecio.value.updated_id
    }

    const rules = {     
      tmovimiento: { required: helpers.withMessage('El campo es requerido!', required), },                 
      tcamion: { required: helpers.withMessage('El campo es requerido!', required), },   
      origen: { required: helpers.withMessage('El campo es requerido', requiredIf(() => form.tmovimiento.tipo === 'NORMAL')), },
      destino: { required: helpers.withMessage('El campo es requerido', requiredIf(() => form.tmovimiento.tipo === 'NORMAL')), }, 
      precio: { required: helpers.withMessage('El campo es requerido!', required), },                    
      km: { required: helpers.withMessage('El campo es requerido!', required), },                       
      vigente: { required: helpers.withMessage('El campo es requerido!', required), },                    
    }

    const confirmDeleteMPrecio = (emp) => {
      mprecio.value = emp
      deleteMPrecioDialog.value = true
    }

    const searchTCamion = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredTCamiones.value = [...tcamiones.value]
        }
        else {
          filteredTCamiones.value = tcamiones.value.filter((tcam) => {
            return tcam._nombre.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchTMovimiento = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredTMovimientos.value = [...tmovimientos.value]
        }
        else {
          filteredTMovimientos.value = tmovimientos.value.filter((tmov) => {
            return tmov._nombre.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchOrigen = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredOrigenes.value = [...origenes.value]
        }
        else {
          filteredOrigenes.value = origenes.value.filter((origen) => {
            return origen._descripcion.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const searchDestino = (event) => {
      setTimeout(() => {
        if (!event.query.trim().length) {
          filteredDestinos.value = [...destinos.value]
        }
        else {
          filteredDestinos.value = origenes.value.filter((dest) => {
            return dest._descripcion.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    }

    const formatCurrency = (value) => {
      return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(value)
    }

    const saveMPrecio = () => {
      submitted.value = true
      if(!v$._value.$invalid){        
        storeMPrecio(form)  
      }
    }

    const setDocumento = (event) => {
      es_normal.value = event.value.tipo === 'NORMAL'
    }    

    const v$ = useVuelidate(rules, form)

    onMounted(getCRUD)

    return {
      dt, 
      loading,
      saving,
      mprecio,
      mprecios,
      filters,
      selectedMPrecios,
      selectedTMovimientos,
      selectedTCamiones,
      deleteMPrecioDialog,
      mprecioDialog,
      submitted,
      filteredTMovimientos,
      filteredDestinos,
      filteredOrigenes,
      filteredTCamiones,
      v$,
      form,
      es_normal,
      setDocumento,
      openNew,
      confirmDeleteMPrecio,
      deleteMPrecio,
      searchTCamion,
      searchOrigen,
      searchDestino,
      searchTMovimiento,
      editMPrecio,
      saveMPrecio,
      storeMPrecio,
      formatCurrency
    }
  },
}
</script>